import { render } from "./ClubDealJoinModal.vue?vue&type=template&id=029d158c&scoped=true&ts=true"
import script from "./ClubDealJoinModal.vue?vue&type=script&lang=ts"
export * from "./ClubDealJoinModal.vue?vue&type=script&lang=ts"

import "./ClubDealJoinModal.vue?vue&type=style&index=0&id=029d158c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029d158c"]])

export default __exports__